module.exports = __webpack_public_path__ + "img/brand-personality-2.c3c65f7d.png";